<template>
  <div class="contract_wrapper" v-if="getItem">
    <div class="page page1">

          <div class="nameBox">
              立契約人 ：賣方<span class="name"></span><br/>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 買方<span class="name"></span>
          </div>
          <ul>
            <li>
              <span class="tit">第一條</span>本契約標的物：
              <div class="li_1_con">
                <ul>
                  <li>商品名稱：<span class="pro">{{getItem.productName}}</span></li>
                  <li>型號規格：<span class="pro">{{getItem.carId}}</span></li>
                  <li>數&nbsp;&nbsp;量：<span class="pro pro_nb">乙</span></li>
                </ul>
              </div>
            </li>
            <li>
              <span class="tit">第二條</span>本契約之價金：單價<span class="mon">{{getItem.vendor.totalPrice}}</span>元整；
              總價<span class="mon">{{getItem.vendor.totalPrice}}</span>元整。
            </li>
          </ul>
          <div class="bt">
            <div class="bt_left">
              <!--名稱--><br/>
              <div class="add">{{getItem.customer.home.residenceAddress}}<!--地址-->
              </div>
            </div>
            <div class="bt_right">
              <!--名稱--><br/>
              <div class="add">{{getItem.contractAddress}}<!--地址--></div>
            </div>
          </div><!--end of bt-->
          <div class="date">
            中華民國<span class="d d1"></span>&nbsp;年<span class="d d2"></span>&nbsp;月<span class="d d3"></span>&nbsp;日
          </div>
        </div><!--page1-->
      </div><!--wrapper-->
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ContractTemplate",
  data() {
    return {
      item: null,
      status: false,
    };
  },
  created() {
    const caseId = this.$route.query.caseId;
    this.status = parseInt(this.$route.query.caseCategory, 10);
    if (caseId) {
      this.fetchFinanceCreditInfo({ caseId }).then((results) => {
        if (results.length) {
          this.item = results[0];
          console.log(`fetchFinanceCreditInfo ${JSON.stringify(this.item)}`);
        }
      });
    }
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    getItem() {
      return this.item;
    },
    getCreateDate() {
      return new Date(this.getItem.createDate);
    },
  },
  methods: {
    ...mapActions(["fetchFinanceCreditInfo"]),
  },
};
</script>

<style scoped src="../../assets/css/contract_template.css">
</style>



// WEBPACK FOOTER //
// src/pages/web/ContractTemplate.vue